import { usePlayer } from '../lib/player.js';
import { formatDuration } from './ui.js';

/**
 * A review player, docked at the bottom so you can keep reading the day list while a
 * story plays. It exists to check what was uploaded is what you meant to upload.
 */
export function PlayerBar() {
  const { now, playing, loading, error, positionSec, durationSec, toggle, seek, skip, close } =
    usePlayer();

  if (!now) return null;

  const total = durationSec || 0;
  const pct = total > 0 ? Math.min(100, (positionSec / total) * 100) : 0;

  return (
    <div className="player">
      <div className="player-inner">
        <button
          type="button"
          className="player-play"
          onClick={toggle}
          disabled={loading}
          aria-label={playing ? 'Pause' : 'Play'}
        >
          {loading ? <span className="spin" /> : playing ? '❚❚' : '▶'}
        </button>

        <div className="player-skip">
          <button
            type="button"
            className="btn btn-sm"
            onClick={() => skip(-15)}
            aria-label="Back 15 seconds"
          >
            −15
          </button>
          <button
            type="button"
            className="btn btn-sm"
            onClick={() => skip(15)}
            aria-label="Forward 15 seconds"
          >
            +15
          </button>
        </div>

        <div className="player-meta">
          <div className="player-context">{now.context}</div>
          <div className="player-title truncate">{now.title}</div>
        </div>

        <div className="player-scrub">
          <span className="player-time nums">{formatDuration(Math.floor(positionSec))}</span>
          <div className="player-track">
            <div className="player-fill" style={{ width: `${pct}%` }} />
            <input
              type="range"
              className="player-range"
              min={0}
              max={Math.max(1, Math.floor(total))}
              value={Math.floor(positionSec)}
              onChange={(event) => seek(Number(event.target.value))}
              aria-label="Seek"
            />
          </div>
          <span className="player-time nums">{formatDuration(Math.floor(total))}</span>
        </div>

        <button
          type="button"
          className="btn btn-ghost btn-sm"
          onClick={close}
          aria-label="Close player"
        >
          ✕
        </button>
      </div>

      {error ? <div className="player-error">{error}</div> : null}
    </div>
  );
}
